export const curriculumTabMeta = {
  id: "curriculum",
  label: "CTĐT",
  shortLabel: "CTĐT",
};
